
export class ErrorModel {
    ExceptionId: string;    
    Severity: string;
    Message: string;
    reloadRoute: string;
    shouldRefreshApp: boolean;
    httpError: HttpErrorModel;
    // constructor() {
    // }
    get errorMessage(): string{
        // console.log(JSON.stringify(this));
        return this.Message?this.Message:(this.httpError && this.httpError.message ?this.httpError.message.toString():'Unknow Error');
    }

    get errorCode(): string{
        // console.log(JSON.stringify(this));
        return this.ExceptionId ? this.ExceptionId : (this.httpError && this.httpError.errorCode ? this.httpError.errorCode.toString():'UNKNOWN');
    }
}


export class HttpErrorModel{
    errorCode: string;    
    message: string;
    constructor(code: string, message: string) {
        // super();
        this.errorCode = code;
        this.message = message;
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/core/error.model.ts